<template>
    <csp-desktop-info-card
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_company_group"
        title="Firmengruppe"
        @cancel-form="handleCancel"
        @save="saveFirmGroupBasedata">
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Name"
                property="name"
                required
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Firmennummer"
                property="firmNumber"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Firmengruppennummer"
                property="firmGroupNumber"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Adressnummer"
                property="addressNumber"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Versicherungsnummer"
                property="insuranceNumber"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Firmenebene"
                :options-loader="loadOptions('firmLevel')"
                property="firmLevel"
                type="autocomplete"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Rechnungsempfänger Name"
                property="accountingName"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Rechnungsempfänger Straße"
                property="accountingStreet"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Rechnungsempfänger PLZ"
                property="accountingPostalCode"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Rechnungsempfänger Ort"
                property="accountingPlace"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Rechnungsempfänger E-Mail"
                property="accountingEmail"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3 align-content-end"
                :form-context="formContext"
                :hide-label="true"
                label="Manuelle Nachbearbeitung Rechnung"
                property="invoiceNeedsManualAdjustment"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Deckelung Autohaus Haftpflichtgebühr je Monat"
                property="monthlyFeeCap"
                type="number"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Fußtext"
                property="footerText"
                type="autogrowtextarea"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Besonderheiten Abrechnung"
                property="billingModalityRemarks"
                type="autogrowtextarea"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :hide-label="true"
                label="Rechtlich identische Filialen"
                property="hasLegallyIdenticalFirms"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :hide-label="true"
                label="Anlieferungs-Vorgänge aktivieren"
                property="enableDeliveryClaims"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :hide-label="true"
                label="2-Faktor Authentifizierung erforderlich"
                property="requires2fa"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :hide-label="true"
                label="Schadenpositionen mit KI anlegen"
                property="canCreateCostUnitsWithOcr"
                type="checkbox"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :hide-label="true"
                label="Nutzung von Kundenvorlagen"
                property="canUseCustomerTemplates"
                type="checkbox"/>
        </b-row>

        <b-row v-if="showActionButtons" class="mt-3">
            <b-col cols="6"/>
            <b-col class="text-right" cols="6">
                <b-button v-if="showDeleteButton" @click="openDeleteConfirmationModal">
                    Firmengruppe löschen
                </b-button>
            </b-col>
        </b-row>

        <b-modal v-model="isDeleteConfirmationModalOpen" cancel-title="Abbrechen" title="Firmengruppe löschen"
            @ok="deleteFirmGroup">
            Wollen Sie die Firmengruppe wirklich löschen?
        </b-modal>
    </csp-desktop-info-card>
</template>

<script>
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import Container from '@services/Container';

    const container = Container.getInstance();
    const firmGroupRepository = container.getDesktopFirmGroupRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        name: 'FirmGroupBasedata',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
            isCreationForm: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            const firmGroupId = this.$route.params.firmGroupId;
            return {
                firmGroupId,
                isDeleteConfirmationModalOpen: false,
            };
        },
        computed: {
            showActionButtons() {
                return this.showDeleteButton;
            },
            showDeleteButton() {
                return this.formContext.data.isEntityNew === false
                    && !this.formContext.isInEditMode
                    && this.formContext.permissions.canDelete === true;
            },
        },
        methods: {
            loadOptions(type, urlParameter = {}) {
                return () => {
                    return firmGroupRepository.loadLegacySelectOptions(type, urlParameter);
                }
            },
            saveFirmGroupBasedata(formContext) {
                if (this.isCreationForm) {
                    this.saveCreate(formContext);
                } else {
                    this.saveUpdate(formContext);
                }
            },
            saveCreate(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmGroupRepository.create(postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
            saveUpdate(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmGroupRepository.saveFirmGroupBasedata(objectId, postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
            handleCancel() {
                // only relevant for creation form
                if (!this.isCreationForm) {
                    return;
                }

                window.history.back();
            },
            openDeleteConfirmationModal() {
                this.isDeleteConfirmationModalOpen = true;
            },
            deleteFirmGroup() {
                this.formContext.isLoading++;
                firmGroupRepository.delete(this.firmGroupId).then(
                    () => {
                        flashMessenger.addSuccess('Firmengruppe wurde gelöscht');
                        window.location.href = '/de/Schaden-Manager/firmgroup';
                    },
                    () => {
                        flashMessenger.addError('Firmengruppe konnte nicht gelöscht werden');
                    }
                ).finally(() => {
                    this.formContext.isLoading--;
                });
            },
        },
    }
</script>
